import React from "react";
import "./style.css";
import { Table } from "antd";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";
import { formateDateAndTime, toTitleCase } from "../../../helper";
import { useSelector } from "react-redux";

const Payments = () => {
  const myOrganization = useSelector((state) => state.general?.myOrganization);

  const allSubscriptions = myOrganization?.subscriptions || [];

  // Flatten all invoices:
  // const paymentRows = allSubscriptions.flatMap((sub) => {
  //   if (sub.invoices && sub.invoices.length > 0) {
  //     return sub.invoices.map((inv) => ({
  //       subscriptionType: toTitleCase(sub.interval),
  //       ...inv,
  //     }));
  //   }
  //   return []; // skip if no invoices
  // });
  const paymentRows = allSubscriptions
    .flatMap(
      (sub) =>
        sub.invoices?.map((inv) => ({
          subscriptionType: toTitleCase(sub.interval),
          ...inv,
        })) ?? []
    )
    .sort((a, b) => {
      const da =
        a.paid_at || a.created_at || a.invoice_date || a.date || a.updated_at;
      const db =
        b.paid_at || b.created_at || b.invoice_date || b.date || b.updated_at;
      const toTs = (s) => (s ? Date.parse(s.replace(" ", "T")) || 0 : 0);
      return toTs(db) - toTs(da); // latest first
    });

  const columns = [
    {
      title: "Subscription Type",
      key: "subscriptionType",
      render: (_, record) => {
        const type = record?.subscriptionType?.toLowerCase();
        if (!type) return "-";
        if (type.endsWith("l")) {
          return toTitleCase(type); // Already ends with "l", e.g., "trial"
        }
        return toTitleCase(type + "ly"); // Make "month" -> "monthly", "year" -> "yearly"
      },
    },
    {
      title: "Payment Date",
      key: "paid_at",
      render: (_, record) => formateDateAndTime(record?.paid_at, "DD MMM YYYY"),
    },
    {
      title: "Amount",
      key: "amount_paid",
      render: (_, record) =>
        record?.amount_paid
          ? `${new Intl.NumberFormat("en-US").format(
              (record.amount_paid / 100).toFixed(2)
            )} USD`
          : "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        if (!record?.receipt_url) return "-";
        return (
          <div
            className="center_align_digits"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              cursor: "pointer",
              backgroundColor: "#F5F5F5",
              border: "1px solid #E0E0E0",
              padding: "6px 12px",
              borderRadius: 8,
              height: 40,
              width: "fit-content",
            }}
            onClick={() => {
              window.open(record?.receipt_url, "_blank", "noopener,noreferrer");
            }}
          >
            <img src={dentalIcons.download} alt="download icon" />
            <p>Download Receipt</p>
          </div>
        );
      },
    },
  ];

  return (
    <div className="payments_container">
      <div className="payments_body">
        <div className="payments_body_table_section">
          <div className="payments_body_table_heading">
            <p className="_title">Payments</p>
          </div>
        </div>
        <br />
        <Table
          dataSource={paymentRows}
          className="_rounded_table"
          pagination={false}
          columns={columns}
          rowKey={(row) =>
            `${row.subscriptionType}-${row.paid_at}-${row.amount_paid}`
          }
        />
      </div>
    </div>
  );
};

export default Payments;
